import { Label as SemanticLabel } from "semantic-ui-react";

export default function Label(props) {
	return <SemanticLabel circular {...props} />;
}

Label.Detail = SemanticLabel.Detail;
